import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import AuthContext from '../contexts/AuthContext';
import '../index.css';
import SelectBox from './SelectBox';
import ModeContext from '../contexts/ShopModeContext';

function Header({ history }) {
  const { auth } = useContext(AuthContext);
  const { shopMode, setShopMode, linkedShop } = useContext(ModeContext);
  const shopModeSelectOptions =
    linkedShop === 'both'
      ? ['카페24', '메이크샵']
      : [linkedShop === 'cafe24' ? '카페24' : '메이크샵'];

  const handleModeChange = (selectedOption) => {
    if (selectedOption === '카페24') {
      setShopMode('cafe24');
    }
    if (selectedOption === '메이크샵') {
      setShopMode('makeshop');
    }
  };

  return (
    <header className="App-header">
      <div style={{ height: 44 }}>
        {auth && (
          <LogoutButton
            onClick={() => {
              window.sessionStorage.clear();
              window.localStorage.clear();
              window.location.replace('/');
            }}
          >
            로그아웃
          </LogoutButton>
        )}
      </div>
      <div style={{ height: 80 }}>
        <img
          alt="logo"
          onClick={
            auth
              ? () => {
                  history.push({
                    pathname: '/mypage/setting',
                  });
                }
              : () => {
                  let result = window.confirm(
                    '입력된 정보가 사라질 수 있습니다. 그래도 메인으로 돌아가시겠습니까?'
                  );

                  if (result) {
                    history.push({
                      pathname: '/',
                    });
                    window.sessionStorage.clear();
                  }
                }
          }
          src={
            ' https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-wizmon-logo.png'
          }
          style={{ cursor: 'pointer' }}
        />
        {auth && shopMode && (
          <SelectBoxWrapper>
            <SelectBox
              header={true}
              width={215}
              options={shopModeSelectOptions}
              onSelect={handleModeChange}
              defaultOption={shopMode === 'cafe24' ? '카페24' : '메이크샵'}
              disabled={
                window.location.pathname === '/mypage/contents-management' ||
                window.location.pathname === '/mypage/content-posting-setting'
              }
            />
          </SelectBoxWrapper>
        )}
      </div>
    </header>
  );
}
export default withRouter(Header);

const LogoutButton = styled.button`
  background-color: white;
  border-width: 0;
  color: #737373;
  float: right;
  cursor: pointer;
  margin-top: 15px;
  font-size: 15px;
`;

const SelectBoxWrapper = styled.div`
  float: right;
  margin-top: 10px;
`;
